import { render } from "./PageConfirm.vue?vue&type=template&id=16f138a6&ts=true"
import script from "./PageConfirm.vue?vue&type=script&lang=ts"
export * from "./PageConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__